// extracted by mini-css-extract-plugin
export default {"Typography":"Typography_Typography__phe9E","t14":"Typography_t14__WGdvL","t16":"Typography_t16__bvoyd","Subtext":"Typography_Subtext__eYjl0"};